"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getById = getById;
exports.queryList = queryList;
exports.update = update;
var _requestPIM = _interopRequireDefault(require("@/utils/requestPIM"));
// 分组编辑
function update(data) {
  return (0, _requestPIM.default)({
    url: '/xyGoodsCategory/updateXyGoodsCategory',
    method: 'post',
    data: data
  });
}

// 查询菜单分类id
function getById(id) {
  return (0, _requestPIM.default)({
    url: '/xyGoodsCategory/' + id,
    method: 'get'
  });
}

// 菜单分类列表
function queryList(query) {
  return (0, _requestPIM.default)({
    url: '/xyGoodsCategory/page',
    method: 'get',
    params: query
  });
}